var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_setup.imageUrl)?_c('div',{staticClass:"w-100 p-2"},[_c('b-card',{attrs:{"nobody":"","body-class":"p-1"}},[_c('b-img',{attrs:{"src":_setup.imageUrl,"fluid":""}})],1)],1):_c('div',[_c('b',[_vm._v("Image is not found")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }